import React, { FC, useEffect, useState, useRef } from "react";
import { AEAStepper, AEAStep, BasicDataBudget } from "@/components/";
import styles from "./form-budget.module.scss";
import { IFormBudget } from "@interfaces/screens/form-budget.interface";
import { FormBudgetPresenter } from "@presenters/screens/form-budget.presenter";
import { Container, Row, Button, Form } from "reactstrap";
import FormBudgetDetails from "./form-budget-details/form-budget-details";
import ValidationGroup from "devextreme-react/validation-group";

const FormBudget: FC<any> = () => {
  const [readOnly, setReadOnly] = useState(false);
  let validationGroup = useRef(null);

  const view: IFormBudget = {
    state: {
      readOnly: readOnly,
      setReadOnly: setReadOnly,
    },
  };
  const presenter = new FormBudgetPresenter(view);
  
  useEffect(() => {
    presenter.onInitialize();
    presenter.getAllFormMasters();
  }, []);

  useEffect(() => presenter.onSaveData(), [presenter.formSaveBudget]);

  if (presenter.initRender) {
    return (
      <Container fluid={true}>
        <Form
          className={
            view.state.readOnly ? styles.ReadOnly : styles.InheritAction
          }
        >
          <ValidationGroup ref={validationGroup}>
            <Row>
              <AEAStepper
                activeAll={view.state.readOnly}
                defaultStep={presenter.getLabel("Datos básicos")}
                activateValidation={view.state.readOnly}
                errorSelectors={[".dx-invalid"]}
              >
                <AEAStep title={presenter.getLabel("Datos básicos")}>
                  <BasicDataBudget></BasicDataBudget>
                </AEAStep>
                <AEAStep title={presenter.getLabel("Presupuesto")}>
                  <FormBudgetDetails></FormBudgetDetails>
                </AEAStep>
              </AEAStepper>
            </Row>
          </ValidationGroup>
        </Form>
        <Row>
          {!view.state.readOnly ? (
            <Button
              className={styles.BottomButton}
              onClick={(e) => {
                const response = validationGroup.current.instance.validate();
                if (response.isValid) {
                  presenter.save();
                }
              }}
            >
              {presenter.getLabel("Guardar")}
            </Button>
          ) : (
            <div></div>
          )}
          <Button
            className={styles.BottomButton}
            onClick={() => presenter.OnRedirect("/proyecta/presupuesto")}
          >
            {presenter.getLabel("Cancelar")}
          </Button>
          {presenter.isAllowEdit ? (
            <Button
              className={styles.BottomButton}
              onClick={() => presenter.OnRedirect("/proyecta/presupuesto/new")}
            >
              {presenter.getLabel("Nuevo")}
            </Button>
          ) : (
            <div></div>
          )}
        </Row>
      </Container>
    );
  } else {
    return <div></div>;
  }
};

export default FormBudget;
